"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlayNovoDark = exports.overlayNovo = exports.overlay = void 0;
const polished_1 = require("polished");
const styled_components_1 = require("styled-components");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const animation = (0, styled_components_1.keyframes) `from { opacity: 0; } to { opacity: 1; }`;
const fadeInAnimation = (0, styled_components_1.css) `
  animation: ${animation} ${timing_const_1.default.fast} ease-in;
`;
const fadeInAnimationNovo = (0, styled_components_1.css) `
  animation: ${animation} 150ms ease-in;
`;
const overlay = {
    backgroundColor: (0, polished_1.rgba)(color_const_1.default.cloudyBlue100, 0.75),
    animation: fadeInAnimation,
    zIndex: zIndex_const_1.default.z1000,
};
exports.overlay = overlay;
const overlayNovo = {
    backgroundColor: novo.overlay01,
    animation: fadeInAnimationNovo,
    zIndex: zIndex_const_1.default.z1000,
};
exports.overlayNovo = overlayNovo;
const overlayNovoDark = {
    ...overlayNovo,
    backgroundColor: novoDark.overlay01,
};
exports.overlayNovoDark = overlayNovoDark;
